import clsx from "clsx"

import clsxm from "@/lib/clsxm"
import { timeslotToLocaleTimeString } from "@/lib/time"

import { AppointmentType } from "@/components/Booking/AppointmentType"
import { Location } from "@/components/Booking/Location"
import { Price } from "@/components/Booking/Price"
import { SummaryBlock } from "@/components/Booking/SummaryBlock"
import { Timeslot } from "@/components/Booking/Timeslot"

import { useStepper } from "@/context/BookingContext"

export type BookingSummaryProps = {
  className?: string
  style?: `light-gray` | `white`
  forceDesktopStyle?: boolean
}

export default function BookingSummary({
  className,
  style = `light-gray`,
  forceDesktopStyle,
}: BookingSummaryProps) {
  // Put Header or Footer Here
  const {
    appointmentDetails: {
      address_1,
      address_2,
      appointmentType,
      post_code,
      practice,
      practitioner,
      price_cents,
      timeslot,
    },
  } = useStepper()

  return (
    <div className={clsxm(``, className)}>
      {/* Mobile */}
      {!forceDesktopStyle && (
        <div className={`block text-lg sm:hidden`}>
          <p className={`text-2xl font-bold`}>{practice}</p>
          {appointmentType ? (
            <p>
              {appointmentType} on {timeslotToLocaleTimeString(timeslot)}
              {practitioner ? ` with ${practitioner}` : null}
            </p>
          ) : (
            <p className={``}>
              Booking for {timeslotToLocaleTimeString(timeslot)}
            </p>
          )}
        </div>
      )}

      {/* Desktop */}
      <div
        className={clsx(
          `space-y-3 sm:block`,
          forceDesktopStyle ? `block` : `hidden`
        )}
      >
        <Location
          address_1={address_1}
          address_2={address_2}
          post_code={post_code}
          practice={practice}
          style={style}
        />

        <Timeslot style={style} timeslot={new Date(timeslot)} />

        <AppointmentType
          appointmentType={appointmentType}
          practitioner={practitioner}
          style={style}
        />

        <Price price_cents={price_cents} style={style} />
      </div>
    </div>
  )
}

const SummaryBlockNameSpace = Object.assign(SummaryBlock, {
  AppointmentType,
  Location,
  Timeslot,
})

export { SummaryBlockNameSpace as SummaryBlock }
